<template>
    <div id="filter_advanced">
        <div class="ui form" @keypress.enter="$parent.$parent.user_logs_filter()">
            <div class="three fields">
                <div class="field">
                    <label>{{ $t('models.attributes.user_logs.loggable_type') }}</label>
                    <input type="text"
                        v-model="filter.columns.loggable_type"
                    >
                </div>
                <div class="field">
                    <label>{{ $t('ui.pages.user_logs.operator') }}</label>
                    <input type="text"
                        v-model="filter.columns.staff_name"
                    >
                </div>
                <div class="field">
                    <label>{{ $t('models.attributes.user_logs.title') }}</label>
                    <input type="text"
                        v-model="filter.columns.title"
                    >
                </div>
            </div>
            <div class="two fields">
                <div class="field">
                    <label>{{ $t('models.attributes.user_logs.action_type') }}</label>
                    <input type="text"
                        v-model="filter.columns.action_type"
                    >
                </div>
                <div class="field">
                    <label>{{ $t('models.attributes.user_logs.created_at') }}</label>
                    <DatePicker
                        v-model="filter.columns.created_duration"
                        format="YYYY-MM-DD"
                        type="daterange"
                        key="user_logs_advanced_created_at"
                        :re_init="Boolean(filter.columns.created_duration)"
                    >
                    </DatePicker>
                </div>

            </div>
        </div>

        <div
            class="ui icon blue button right floated"
            @click="$parent.$parent.user_logs_filter()">
            <i class="search icon"></i>
            {{ $t('ui.general.search') }}
        </div>
        <div class="clear">

        </div>
    </div>
</template>

<script>
import DatePicker from "@toolbox/date_picker/main.vue"

export default {
    name: "CustomersFilterAdvanced",
    data() {
        return {
            is_initialized: false,
        }
    },
    computed: {
        current_store() {
            return this.$store.state.provider.user_logs_module
        },
        filter() {
            return this.current_store.filter
        },
    },
    created() {
    },
    mounted() {
    },
    watch: {
    },
    methods: {
    },
    components: {
        DatePicker
    }
}
</script>

<style>
.el-date-editor.el-range-editor input {
    border: none !important;
}
</style>
